/**
 * How many plan cards a row shows side by side, given how many it holds and how wide it is.
 *
 * A card has a minimum width below which its feature lines break mid-phrase, so when the
 * row can't fit every card at that width it shows fewer per line — but never a count that
 * leaves one card alone on the last line (3 + 1 for four plans), which reads as a mistake.
 * Two per line is always offered as the last resort; stacking to one is the stylesheet's
 * job below the mobile breakpoint.
 */

/** The counts a row of `count` cards may use, widest first: `count` itself, then fewer. */
export function rowColumnOptions(count: number): number[] {
  const options = [Math.max(count, 1)];
  for (let columns = count - 1; columns >= 2; columns--) {
    // `count % columns === 1` is the lone orphan; skip it. Two is the floor and always in.
    if (columns === 2 || count % columns !== 1) options.push(columns);
  }
  return options;
}

/** The row width `columns` cards need at `minCardWidth` each, with `gap` between them. */
export function rowWidthFor(columns: number, minCardWidth: number, gap: number): number {
  return columns * minCardWidth + Math.max(columns - 1, 0) * gap;
}
